<template>
    <v-container fill-height>
        <v-layout align-center justify-center>
            <v-progress-circular indeterminate>
            </v-progress-circular>
        </v-layout>
    </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: 'LogoutPage',
    mounted() {
        setTimeout(() => {
            this.$store.dispatch("auth/logout").then(() => {
                this.$router.push({name: 'device-list'});

            });
            
        }, 1000);

    }
  
};
</script>

<style scoped>
</style>